<template>
	<div id="app">
		<Base v-if="baseFlag" @onOrOff="onOrOff"/>
		<div class="container" :style="{paddingLeft:paddingLeft}">
			<router-view/>
		</div>
	</div>
</template>

<script>
import Base from '../src/components/base'
export default {
	name: 'App',
	components:{
		Base
	},
	created(){
		var url = window.location.href;
		if(url.indexOf('Login')>=0 || url.indexOf('NoPermission')>=0){
			this.baseFlag=false
		} else {
			this.baseFlag=true
		}
	},
	updated(){
		var url = window.location.href;
		if(url.indexOf('Login')>=0  || url.indexOf('NoPermission')>=0){
			this.baseFlag=false
		} else {
			this.baseFlag=true
		}
	},
	data(){
		return{
			baseFlag:false,
			paddingLeft:'240px'
		}
	},
	methods:{
		onOrOff(e) {
			e=='isOn'?this.paddingLeft='70px':this.paddingLeft='240px'
		}
	}
}
</script>

<style>
@import '../src/assets/css/reset.min.css';
.container{
	padding-top: 60px;
    /* padding-left: 240px; */
    padding-right: 20px;
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue